import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";

export default function SearchRecordForm({ formInit, cancelForm, getValues, isLoading }) {
  const [initialValues, setInitialValues] = useState({});

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      console.log("Submitted values:", values);
      getValues(values);
    },
  });
  useEffect(() => {
    if (formInit && Object.keys(formInit).length > 0) {
      const updatedInitialValues = Object.keys(formInit).reduce((acc, key) => {
        const fieldData = formInit[key]; // Get the inner object
        const fieldName = key || ""; // Ensure inner object exists
        if (
          fieldData?.value === "https://www.linkedin.com/company/null" ||
          fieldData?.value === "https://www.linkedin.com/company/null/"
        ) {
          acc[fieldName] = "";
        } else {
          acc[fieldName] = fieldData?.value || ""; // Get the value, fallback to an empty string
        }
        return acc;
      }, {});

      setInitialValues(updatedInitialValues); // Set initial values once object is populated
    }
  }, [formInit]); // Re-run the effect when formInit changes
  return (
    <form className="animate__animated animate__fadeIn text-left p-4">
      {Object.keys(formInit).map((key, index) => {
        const fieldData = formInit[key]; // Get the inner object
        const inputName = key || ""; // Ensure the inner object exists

        return (
          <div className="mb-3" key={index}>
            <p className="mb-2 text-text-700 text-sm">{fieldData?.label}</p>
            <input
              type="text"
              name={inputName}
              className="rounded-[8px] w-full bg-background border border-gray-300 text-gray-900 text-[14px] p-2 h-10"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values[inputName] || ""} // Provide a fallback empty string
            />
          </div>
        );
      })}

      <div className="flex items-center mt-4">
        <button
          disabled={isLoading}
          onClick={(e) => {
            e.preventDefault();
            formik.handleSubmit();
          }}
          className="text-[14px] disabled:opacity-70 flex w-6/12 justify-center items-center py-2 h-9 space-x-2 px-4 rounded-[8px] text-white bg-brand-600 dark:bg-brand-300 border border-brand-600 "
        >
          <MagnifyingGlassIcon width={18} height={18} className="mr-1" />
          Search
          {isLoading && <div className="loader_circle ml-2"></div>}
        </button>
        <span
          onClick={cancelForm}
          className="cursor-pointer inline-flex justify-center items-center whitespace-nowrap text-sm transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 border bg-transparent border-transparent text-gray-600 px-4 py-2 h-9 rounded-[8px]"
        >
          Cancel
        </span>
      </div>
    </form>
  );
}
